import {
  createFileRoute,
  Link,
  Outlet,
  useLocation,
} from "@tanstack/react-router";

import { ROUTES } from "$/lib/utils/constants/routes.constants";
import { cn } from "$/lib/utils/functions/misc.functions";

import HelpMobileNavigation from "./-features/components/HelpMobileNavigation";

export const Route = createFileRoute("/_user-layout/help/_help-layout")({
  component: HelpLayout,
});

const items = [
  {
    label: "Vidéo de présentation de Libe",
    route: ROUTES.HELP_VIDEO,
  },
  {
    label: "Catégoriser mes transactions",
    route: ROUTES.HELP_MYTRANSACTIONS,
  },
  {
    label: "Ajuster mes transactions",
    route: ROUTES.HELP_TRANSACTION_ACTIONS,
  },
  {
    label: "Gérer la connexion bancaire",
    route: ROUTES.HELP_BANKING,
  },
  {
    label: "Importer des données supplémentaires",
    route: ROUTES.HELP_MYACTIVITY,
  },
  {
    label: "Suivre mon activité",
    route: ROUTES.HELP_SOCIALSECURITY,
  },
  {
    label: "Déclarer des charges particulières",
    route: ROUTES.HELP_SPECIAL_CHARGES,
  },
  {
    label: "Gérer mes cotisations sociales",
    route: ROUTES.HELP_TAXES,
  },
  {
    label: "Gérer mon imposition",
    route: ROUTES.HELP_OPTIMIZATION,
  },
  {
    label: "Comprendre ma synthèse",
    route: ROUTES.HELP_PROFILE,
  },
  {
    label: "Optimiser mes revenus",
    route: ROUTES.HELP_MYOPTIMIZATION,
  },
];

function HelpLayout() {
  const location = useLocation();

  return (
    <div className="mt-6 flex w-[93%] mx-auto screen850:w-full flex-col gap-12 screen850:mt-8">
      <div className="flex max-w-[1200px] flex-col gap-8 screen850:flex-row screen850:justify-between screen850:gap-20">
        <div className="flex flex-col gap-4 screen850:gap-8">
          <h2 className="leading-none whitespace-nowrap text-base font-bold">
            Comment fonctionne Libe ?
          </h2>
          <div className="relative ml-4 hidden !w-[229px] flex-col gap-8 before:absolute before:left-0 before:top-0 before:h-full before:w-[1px] before:-translate-x-4 before:rounded-md before:bg-textInfo before:opacity-100 before:transition-opacity before:content-[''] screen850:flex">
            {items.map((item, index) => {
              const isActive = item.route === location.pathname;

              return (
                <Link
                  key={index}
                  to={item.route}
                  className={cn(
                    "relative h-5 justify-start whitespace-nowrap bg-transparent p-0 text-left text-sm font-medium text-textInfo duration-200",
                    { "font-semibold text-textColor": isActive },
                  )}
                >
                  {item.label}
                </Link>
              );
            })}

            <HelpLayoutLinkIndicator />
          </div>
          <div className="screen850:hidden">
            <HelpMobileNavigation items={items} />
          </div>
        </div>
        <div className="flex-1">
          <Outlet />
        </div>
      </div>
    </div>
  );
}

function HelpLayoutLinkIndicator() {
  const location = useLocation();
  const activeLinkIndex = items.findIndex(
    (item) => item.route === location.pathname,
  );

  return (
    <div
      className="absolute -left-4 top-0 h-12 w-1 rounded-md bg-secondary-300 duration-300"
      style={{
        // 1.25rem is the height of the link
        // 2rem is the gap between each link
        transform: `translate(calc(-50% + 0.5px), calc(-30% + ${activeLinkIndex * (1.25 + 2)}rem))`,
      }}
    ></div>
  );
}
